export default __webpack_public_path__ + "static/media/add.467fef0a.svg";